import clsx from "clsx";
import React, { cloneElement } from "react";
import { colors } from "../../colors";
import "./Input.css";
import { InputProps } from "./Input.types";

const TextArea: React.FC<InputProps> = ({
    onChange,
    ...props
}) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px', width: '100%' }}>
            {props.label && <span className="input-label">{props.label}</span>}
            <div
                className="text-area-container"
                style={{
                    backgroundColor: props.disabled
                        ? 'rgba(242, 242, 250, 1)'
                        : 'white',
                    borderColor: props.error
                        ? 'rgba(255, 198, 194, 1)'
                        : '#ADADD6',
                }}
            >
                {props.startIcon && (
                    <div style={{ maxHeight: '20px' }}>
                        {cloneElement(props.startIcon, {
                            color: colors.neutral[500],
                            size: 16,
                        })}
                    </div>
                )}
                <textarea
                    autoFocus={props.autoFocus}
                    autoComplete={props.autocomplete}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    value={props.value}
                    defaultValue={props.defaultValue}
                    onKeyDown={e => props.onKeyDown && props.onKeyDown(e)}
                    onChange={(e) => {
                        props.onChangeText && props.onChangeText(e.target.value);
                    }}
                    className={`text-area-value ring-0 placeholder:text-label-sm placeholder:text-neutral-400 placeholder:font-regular focus:ring-0 ${props.error ? 'text-area-value-error' : ''
                        }`}
                    style={{
                        resize: "none",
                        border: 0,
                        outline: 0,
                        padding: 6,
                        height: '100%',
                        backgroundColor: props.disabled ? 'rgba(242, 242, 250, 1)' : 'white',
                        width: '100%',
                    }}
                />
                {props.endIcon && (
                    <div style={{ maxHeight: '20px' }}>
                        {cloneElement(props.endIcon, {
                            color: colors.neutral[500],
                            size: 16,
                        })}
                    </div>
                )}
            </div>
            {props.supportingText && (
                <span
                    className={clsx('text-text-sm', {
                        'text-red-500': props.error,
                        'text-neutral-400': !props.error,
                    })}
                >
                    {props.supportingText}
                </span>
            )}
        </div>
    );
};

export default TextArea;
